import React from 'react';
import * as HERBUI from 'react-bootstrap'
import { usermanualshrpayroll } from '../components/Functions';
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization } from '../Api/CommonAjaxUtils';
import { AWS_DOWNLOAD_URL } from '../Api/APIURLS';
function PensionsMobileNumbersPopUp({ showpopup, handleClose }) {

    const getS3UrlData = async (url) => {
        const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
            AWS_DOWNLOAD_URL + url
        );
        if (resp) {
            window.open(resp, "_blank");
        }
    }
    const nodalOfficers = [
        { sl: 1, district: "61 - Srikakulam", officer: "Sri P. Gojaraju", designation: "ATO", mobile: "9791293240", email: "goga7raj@gmail.com" },
        { sl: 2, district: "62 - Vizianagaram", officer: "Sri L. V. Yugandhar", designation: "STO", mobile: "9490284272", email: "yugandhar140180@gmail.com" },
        { sl: 3, district: "63 - Parvathipuram Manyam", officer: "Sri B Sateesh", designation: "STO", mobile: "9491810135", email: "satish.july05@gmail.com" },
        { sl: 4, district: "64 - Alluri Sitharama Raju at Paderu", officer: "Sri P Krupa Rao", designation: "STO", mobile: "9441586186", email: "krupapathivada.76@gmail.com" },
        { sl: 5, district: "65 - Visakhapatnam", officer: "Sri D. Appalaraju", designation: "STO", mobile: "9441431395", email: "stobml@gmail.com" },
        { sl: 6, district: "66 - Anakapalli", officer: "Sri J. Ratnaji Rao", designation: "STO", mobile: "9951602064", email: "dtoakpasection@gmail.com" },
        { sl: 7, district: "67 - Kakinada", officer: "Sri Md. Jahiruddin", designation: "STO", mobile: "9951603786", email: "jahir0300084@gmail.com" },
        { sl: 8, district: "68 - Konaseema at Amalapuram", officer: "Sri A N V V S R Bheemeswara Rao.", designation: "STO", mobile: "9848699970", email: "bheemesh9atkuri@gmail.com" },
        { sl: 9, district: "69 - East Godavari at Rajamahendravaram", officer: "Sri N. Sameer Krishna", designation: "ATO", mobile: "9951602142", email: "dtao.rjy3601@gmail.com" },
        { sl: 10, district: "70 - West Godavari at Bhimavaram", officer: "Sri Mohammad Arshad Omar", designation: "STO", mobile: "8179121829", email: "Arshadomar220916@gmail.com" },
        { sl: 11, district: "71 - Eluru District.", officer: "Smt T. Bharathi", designation: "STO", mobile: "9063640918", email: "asec.dtaoeluru@gmail.com" },
        { sl: 12, district: "72 - Krishna at Machilipatnam", officer: "Sri P. Lakshmi Narayana", designation: "STO", mobile: "9951602159", email: "stoadtk@gmail.com" },
        { sl: 13, district: "73 - NTR at Vijayawada", officer: "Sri B. Satetesh", designation: "STO", mobile: "9059093110", email: "dtaontrvja@gmail.com" },
        { sl: 14, district: "74 - Guntur", officer: "Smt V.N.Vijaya Durga", designation: "STO", mobile: "6303319624", email: "Vijayaakhi@gmail.com" },
        { sl: 15, district: "75 - Bapatla", officer: "Smt D. Rajyalakshmi", designation: "STO", mobile: "9912526500", email: "Raji.apts@gmail.com" },
        { sl: 16, district: "76 - Palnadu at Narasaraopet", officer: "Sri D. Vijayasagar", designation: "STO", mobile: "9573034150", email: "darivemulasagar7@gmail.com" },
        { sl: 17, district: "77 - Prakasam at Ongole", officer: "Sri P.V.L.N. Vara Kumar", designation: "STO", mobile: "7386800485", email: "dtoongolenodalofficer@gmail.com" },
        { sl: 18, district: "78 - Sri Potti Sriramulu Nellore", officer: "Sri M S V N B M Prasad", designation: "ATO", mobile: "9441870202", email: "prasadmallikarjuna@yahoo.com" },
        { sl: 19, district: "79 - Kurnool", officer: "Sri E. Pradeep Kumar", designation: "STO", mobile: "9966933379", email: "epradeep2001@gmail.com" },
        { sl: 20, district: "80 - Nandyal", officer: "Sri T. Srinivasulu", designation: "ATO", mobile: "9885265007", email: "tumkursreenu1964@gmail.com" },
        { sl: 21, district: "81 - Ananthapuramu", officer: "Sri K. Narayana Reddy", designation: "STO", mobile: "9951602415 / 9885041550", email: "sto1015.sml@gmail.com" },
        { sl: 22, district: "82 - Sri Sathya Sai at Puttaparthy", officer: "Sri M. K. Rajesh", designation: "STO", mobile: "8074309344", email: "Rajeshmk.mattam@gmail.com" },
        { sl: 23, district: "83 - YSR at Kadapa", officer: "Sri T. Venkata Subbaiah", designation: "STO", mobile: "9390266919", email: "tellavenkat66@gmail.com" },
        { sl: 24, district: "84 - Annamayya at Rayachoti", officer: "Sri G. Venkatreddy", designation: "STO", mobile: "9440132106", email: "gundalavenkatreddy@gmail.com" },
        { sl: 25, district: "85 - Chittoor", officer: "Y Siva Kiran", designation: "STO", mobile: "7842524001", email: "dto.chittoor@gmail.com" },
        { sl: 26, district: "86 - Tirupati", officer: "Sri Y. Yogananda Reddy", designation: "STO", mobile: "9492555767", email: "cgrsto@gmail.com" },
        { sl: 27, district: "DTA", officer: "Smt.S.N.S Tulasi Krishna", designation: "STO", mobile: "9951602186", email: "rbpsdta@gmail.com" },
        { sl: 28, district: "DTA", officer: "Smt.M. Naga Pattabhi", designation: "SA", mobile: "9398049932", email: "rbpsdta@gmail.com" },
    ];
    return (
        <div>
            <HERBUI.Modal size='xl' show={showpopup} onHide={handleClose} scrollable={true} dialogClassName="modal-xl modal-dialog2">
                <HERBUI.Modal.Header className="modal-header hr">
                    <HERBUI.Modal.Title>
                        <h5>Nodal Officers</h5>
                    </HERBUI.Modal.Title>
                    <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} ></button>
                </HERBUI.Modal.Header>

                <HERBUI.Modal.Body className="modal-body">
                    {/* ===== User Guides Table ===== */}
                    <h6 className="mb-2"><b>Nodal Officers</b></h6>

                    <HERBUI.Table bordered hover responsive className="table-sm">
                        <thead className="table table-hover table-bordered table-sm text-center">
                            <tr>
                                <th>SL.NO</th>
                                <th>Name of the District</th>
                                <th>Name of the Nodal Officer</th>
                                <th>Designation</th>
                                <th>Mobile No.</th>
                                <th>E - Mail Id.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nodalOfficers.map((item) => {
                                if (item.sl === 27) {
                                    return (
                                        <React.Fragment key="dta-heading">
                                            <tr>
                                                <td colSpan={6} className="text-center fw-bold bg-light">
                                                   <span style={{color:'red'}}> At DTA office</span>
                                                </td>
                                            </tr>
                                            <tr key={item.sl}>
                                                <td className="text-center">{item.sl}</td>
                                                <td>{item.district}</td>
                                                <td>{item.officer}</td>
                                                <td className="text-center">{item.designation}</td>
                                                <td className="text-center">{item.mobile}</td>
                                                <td>{item.email}</td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                }
                                return (
                                    <tr key={item.sl}>
                                        <td className="text-center">{item.sl}</td>
                                        <td>{item.district}</td>
                                        <td>{item.officer}</td>
                                        <td className="text-center">{item.designation}</td>
                                        <td className="text-center">{item.mobile}</td>
                                        <td>{item.email}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </HERBUI.Table>

                    {/* ===== Contact Numbers Table ===== */}
                    <h6 className="mb-2"><b>Technical Supporting Team Contact Numbers</b></h6>

                    <HERBUI.Table bordered hover responsive className="text-center table-sm">
                        <thead
                            style={{
                                fontSize: "13px",
                                textAlign: "center",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                            }}
                            className="table table-hover table-bordered table-sm"
                        >
                            <tr>
                                <th>SL.NO</th>
                                <th>NAME</th>
                                <th>MOBILE NUMBER</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>1</td><td>Venkat</td><td>8008944387</td></tr>
                            <tr><td>2</td><td>Soundarya</td><td>9676075867</td></tr>
                            <tr><td>3</td><td>Gopi</td><td>8374302252</td></tr>

                        </tbody>
                    </HERBUI.Table>

                    {/* ===== Spacer ===== */}
                    <hr className="my-4" />



                </HERBUI.Modal.Body>

                <HERBUI.Modal.Footer className="modal-footer">
                    <HERBUI.Button className="btnClose btn-sm" onClick={handleClose}>
                        <b>Close</b>
                    </HERBUI.Button>
                </HERBUI.Modal.Footer>
            </HERBUI.Modal>
        </div>
    );
}

export default PensionsMobileNumbersPopUp;
